import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environment/environment';
import {
  SponsorCardBackendModel,
  SponsorCardModel,
} from '../models/sponsor-card.model';

@Injectable({
  providedIn: 'root',
})
export class SponsorCardService {
  constructor(private http: HttpClient) {}

  public getActiveSponsorCards(): Observable<SponsorCardModel[]> {
    const formData = new FormData();
    formData.append('mode', 'getActiveSponsorCards');

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: SponsorCardBackendModel[];
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response =>
          response.data.map(card => ({
            id: card.id,
            title: card.title,
            description: card.description,
            image: card.image,
            link: card.link,
            active: card.active,
            idUser: card.id_user,
            cooperationName: card.cooperation_name,
          }))
        ),
        catchError(() => {
          return throwError(() => new Error('Sponsor cards fetch failed'));
        })
      );
  }

  public getSponsorCards(): Observable<any> {
    const formData = new FormData();
    formData.append('mode', 'getSponsorCards');

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: SponsorCardModel[];
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response => response.data),
        catchError(() => {
          return throwError(() => new Error('Sponsor cards fetch failed'));
        })
      );
  }

  public getSponsorCardsBySeminarId(
    seminarId: number
  ): Observable<SponsorCardModel[]> {
    const formData = new FormData();
    formData.append('mode', 'getSponsorCardsBySeminarId');
    formData.append('id', seminarId.toString());

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: SponsorCardModel[];
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response => response.data),
        catchError(() => {
          return throwError(() => new Error('Sponsor cards fetch failed'));
        })
      );
  }

  public getSponsorCardsByCategoryId(
    categoryId: number
  ): Observable<SponsorCardModel[]> {
    const formData = new FormData();
    formData.append('mode', 'getSponsorCardsByCategoryId');
    formData.append('id', categoryId.toString());

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: SponsorCardModel[];
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response => response.data),
        catchError(() => {
          return throwError(() => new Error('Sponsor cards fetch failed'));
        })
      );
  }
}
